import superagent from 'superagent'

export const invoke = async (path, method, payload) => {
    const apiURL = `${process.env['REACT_APP_API_URL']}${path}`

    if (method === 'GET') {
        const res = await superagent
                                .get(apiURL)
        return res
    } else if (method === 'POST') {
        const res = await superagent
                                .post(apiURL)
                                .send(payload)
                                .set('accept', 'json')
        return res
    }
}